module.exports = __webpack_public_path__ + "static/media/flask.ea9f99bc.svg";